import React, { Component } from 'react'
import CSSModules from 'react-css-modules'

import styles from './subjects_grades_subtitle.scss'


class SubjectsGradesSubtitle extends Component {

	render() {
		return (
			<h3 styleName='text'>
				{this.props.text}
			</h3>
		)
	}
}

export default CSSModules(SubjectsGradesSubtitle, styles, {allowMultiple: true})
